import Common from '../../Common';
import Item from './callRouting/item';

interface Body {
	did_type: string
	pbx_did_id?: string | number
	timeout?: string | number
	dst_busy_pbx_destination_id?: string | number
	dst_noanswer_pbx_destination_id?: string | number
	dst_unreachable_pbx_destination_id?: string | number
	dst_busy_pbx_message_id?: string | number
	dst_noanswer_pbx_message_id?: string | number
	dst_unreachable_pbx_message_id?: string | number
	dst_busy_voicemail?: string | number
	dst_noanswer_voicemail?: string | number
	dst_unreachable_voicemail?: string | number
}

const CallRouting = class extends Common {
	item: InstanceType<typeof Item>

	constructor(headers: ApiHeaders) {
		super(headers)

		this.item = new Item(headers);
	}

	async browse(profileId: id) {
		return this.get(`/profile/${profileId}/callrouting`)
	}

	async read(profileId: id, callRoutingId: id) {
		return this.get(`/profile/${profileId}/callrouting/${callRoutingId}`)
	}

	async create(profileId: id, body: Body) {
		return this.post(`/profile/${profileId}/callrouting`, body)
	}

	async update(profileId: id, callRoutingId: id, body: Body) {
		return this.patch(`/profile/${profileId}/callrouting/${callRoutingId}`, body)
	}

	async delete(profileId: id, callRoutingId: id) {
		return this.doDelete(`/profile/${profileId}/callrouting/${callRoutingId}`)
	}
}

export default CallRouting;
